import { TPartnerReqDto } from "@/api/services/main/partner/dtos/form-partner-req.dto";
import { TPartnerForm } from "@/features/talent/types/partnerForm";
import { normalizeString } from "@/utils/string";
import { JAPAN_NATIONALITY_ID } from "@/types/enum";

export const convertPartnerData = (payload: TPartnerForm): TPartnerReqDto => {
  const isSendingOrganization = payload?.sendingOrganization === true;
  const isNotJapan = Number(payload.nationalityId) !== JAPAN_NATIONALITY_ID;
  const shouldClearAddressFields = isSendingOrganization || isNotJapan;

  return {
    id: payload?.id ?? undefined,
    partnerName: normalizeString(payload.partnerName) ?? null,
    nationalityId: payload.nationalityId,
    sendingOrganization: payload?.sendingOrganization ?? null,
    zipCode: shouldClearAddressFields ? null : normalizeString(payload.zipCode),
    address: shouldClearAddressFields ? null : normalizeString(payload.address),
    location: !isNotJapan ? null : normalizeString(payload.location),
    prefecture: shouldClearAddressFields ? null : normalizeString(payload.prefecture),
    city: shouldClearAddressFields ? null : normalizeString(payload.city),
    contactPerson: normalizeString(payload.contactPerson),
    contactMethod: payload?.contactMethod ?? null,
    phoneNumber: normalizeString(payload.phoneNumber),
    email: normalizeString(payload.email),
    laborBureauStatus: payload?.laborBureauStatus ?? null,
    contractInfo: normalizeString(payload.contractInfo),
    billingInfo: normalizeString(payload.billingInfo),
    memo: normalizeString(payload.memo),
    otherContacts: normalizeString(payload.otherContacts),
  };
};
